<template>
    <transition name="fade" mode="out-in">
        <div class="session__show_booking">
            <div class="session__show_booking_actions">
                <component-button
                    v-if="(allowSelfCreateBooking)"
                    @click="openBookNotify"
                    :disabled="!validateSelfCreateBooking"
                    :disabled-hint-active="!validateSelfCreateBooking"
                    :disabled-hint-title="$t('ebs.sessions.show.title.unableBecause')"
                    :disabled-hint-items="bookingValidateErrors"
                    :disabled-hint-extra-title="bookingValidateErrorsExtra.length ? $t('ebs.sessions.show.title.please') : ''"
                    :disabled-hint-extra-items="bookingValidateErrorsExtra"
                    :name="'session-show-booking-actions-bookonto'"
                >{{ $t('ebs.sessions.show.buttons.bookOnto') }}</component-button>
                <component-button
                    :theme="'default'"
                    :border="true"
                    v-if="(allowSelfCancelBooking)"
                    @click="openBookCancelNotify"
                    :disabled="!sessionBookingInfoCancellationAllowed"
                    :name="'session-show-booking-actions-cancel'"
                >{{ $t('ebs.sessions.show.buttons.cancelBooking') }}</component-button>
            </div>
            <div class="session__show_booking_form">
                <pop-notify
                    v-if="(allowSelfCreateBooking)"
                    ref="booknotify"
                    :class="'pop__notify--booking'"
                    :title-text="$t('ebs.sessions.show.text.bookOnTo')"
                    :content-text="sessionBookingFormRequired ? this.$t('ebs.sessions.show.text.pleaseCompleteTheForm') : this.$t('ebs.sessions.show.text.pleaseConfirmYourBooking')"
                    :form-active="sessionBookingFormRequired"
                    :form-fields="bookingFields"
                    :cancel-button-text="$t('ebs.sessions.show.buttons.cancel')"
                    :submit-button-text="$t('ebs.sessions.show.buttons.bookOnto')"
                    :prevent-close="true"
                    @emit-form="updateBookingFields"
                    @emit-submit="createBooking"
                />
                <pop-notify
                    v-if="(allowSelfCancelBooking)"
                    ref="bookcancelnotify"
                    :class="'pop__notify--booking'"
                    :title-text="$t('ebs.sessions.show.buttons.cancelBooking')"
                    :content-text="$t('ebs.sessions.show.text.areYouSure') + '\n\n' + this.$t('ebs.sessions.show.text.coordinatorWillReceive')"
                    :cancel-button-text="$t('ebs.sessions.show.buttons.goBack')"
                    :select-value="bookingCancellationReason"
                    :select-active="sessionCancellationReasonRequired"
                    :select-title="$t('ebs.sessions.show.title.cancellationReason')"
                    :select-items="sessionCancellationReason"
                    :select-items-other="sessionCancellationReasonOther"
                    :submit-button-text="$t('ebs.sessions.show.buttons.cancelBooking')"
                    :submit-button-danger="true"
                    :prevent-close="true"
                    @emit-select="updateBookingCancellationReason"
                    @emit-submit="cancelBooking"
                />
            </div>
        </div>
    </transition>
</template>

<script>
import PopNotify from '@/components/default/shared/PopNotify'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  components: {
    ComponentButton,
    PopNotify
  },
  name: 'session-show-booking',
  computed: {
    eventStatus () {
      return this.$store.getters.getEventStatus
    },
    eventId () {
      return this.$store.getters.getEventId
    },
    sessionStatus () {
      return this.$store.getters.getSessionDefaultStatus
    },
    sessionId () {
      return this.$store.getters.getSessionId
    },
    sessionUserBookingStatus () {
      return this.$store.getters.getSessionUserBookingStatus
    },
    sessionBookingInfoAcceptationAllowed () {
      return this.$store.getters['getSessionBookingInfoAcceptationAllowed']
    },
    sessionBookingInfoCancellationAllowed () {
      return this.$store.getters['getSessionBookingInfoCancellationAllowed']
    },
    sessionCancellationSelfAllowed () {
      return this.$store.getters['getSessionCancellationSelfAllowed']
    },
    sessionCancellationReasonRequired () {
      return this.$store.getters['getSessionCancellationReasonRequired']
    },
    sessionCancellationReason () {
      const items = this.$store.getters['getSessionCancellationReason']
      return this.fromStringToArraySelect(items)
    },
    sessionCancellationReasonOther () {
      return this.$store.getters['getSessionCancellationReasonOther']
    },
    sessionBookingFormRequired () {
      return this.$store.getters['getSessionBookingFormRequired']
    },
    //
    allowSelfCancelBooking () {
      return this.$store.getters.getSessionAllowSelfCancelBooking
    },
    validateSelfCreateBooking () {
      return this.$store.getters.getBookingValidate
    },
    allowSelfCreateBooking () {
      return this.$store.getters.getSessionAllowSelfCreateBooking
    },
    allowValidate () {
      return this.$store.getters.getSessionAllowValidate
    },
    watchComputedValidate () {
      return this.sessionId + this.eventId
    },
    //
    bookingValidate: {
      get () {
        return this.$store.getters['getBookingValidate']
      }
    },
    bookingValidateErrors: {
      get () {
        return this.$store.getters['getBookingValidateErrors']
      }
    },
    bookingValidateErrorsExtra: {
      get () {
        return this.$store.getters['getBookingValidateErrorsExtra']
      }
    },
    bookingFields: {
      get () {
        return this.$store.getters['getBookingFields']
      }
    },
    bookingSuccess: {
      get () {
        return this.$store.getters['getBookingSuccess']
      }
    },
    bookingCancellationReason: {
      get () {
        return this.$store.getters['getBookingCancellationReason']
      }
    }
  },
  mounted () {
    this.$store.dispatch('clearBooking')
    if (this.allowValidate) {
      this.validateBooking()
    }
  },
  watch: {
    watchComputedValidate () {
      if (this.allowValidate) {
        this.validateBooking()
      }
    }
  },
  methods: {
    getEvent () {
      const eventID = this.$route.params.eventId
      this.$store.dispatch('getEventSummary', eventID)
    },
    getSession () {
      const sessionID = this.$route.params.sessionId
      this.$store.dispatch('getSession', sessionID)
    },
    getBooking () {
      const bookingID = this.$store.getters['getSessionUserBookingId']
      this.$store.dispatch('getBooking', bookingID)
    },
    //
    openBookNotify () {
      this.$refs.booknotify.openNotify()
      if (!this.bookingFields.length) {
        this.setBookingFields()
      }
    },
    closeBookNotify () {
      this.$refs.booknotify.closeNotify()
    },
    openBookCancelNotify () {
      this.getBooking()
      this.$refs.bookcancelnotify.openNotify()
    },
    closeBookCancelNotify () {
      this.$refs.bookcancelnotify.closeNotify()
    },
    //
    setBookingFields () {
      this.$store.dispatch('setBookingFields')
    },
    updateBookingFields (data) {
      this.$store.dispatch('updateBookingFields', data)
    },
    updateBookingCancellationReason (data) {
      this.$store.dispatch('setBookingCancellationReason', data)
    },
    //
    validateBooking () {
      this.$store.dispatch('validateBooking')
    },
    createBooking () {
      this.$store.dispatch('createBooking').then(() => {
        this.$eventBus.$emit('perform-get-session')
      }).finally(() => {
        this.closeNotifyCancelBooking()
      })
    },
    cancelBooking () {
      this.$store.dispatch('cancelBooking').then(() => {
        this.$eventBus.$emit('perform-get-session')
      }).finally(() => {
        this.closeBookCancelNotify()
      })
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>
